import React, { useCallback, useEffect, useState } from "react";
import { MODULE_API } from "../../../../apis";
import axios from "axios";
import ROUTES from "../../../../config/routes";
import * as Style from "./styles/Asset-Listing";
import tableimg from "../../../../assets/images/big/camera.png";
import clockIcon from "../../../../assets/SVGs/clock.svg";
import percentIcon from "../../../../assets/SVGs/percent.svg";
import growthIcon from "../../../../assets/SVGs/growth.svg";
import conatinerIcon from "../../../../assets/SVGs/container-volume.svg";
import cashIcon from "../../../../assets/SVGs/cash-dollar.svg";
import purchaseIcon from "../../../../assets/SVGs/purchase-tag.svg";
import calanderIcon from "../../../../assets/SVGs/date-range.svg";
import percentageIcon from "../../../../assets/SVGs/percentage.svg";
import downTrendIcon from "../../../../assets/SVGs/down-trend.svg";
import NewLoader from "../../../../components/styled-components/loader/NewLoader";
import { Modal, Form, Button } from "antd";
import swal from "sweetalert";
import { Link, useHistory } from "react-router-dom";
import addIcon1 from "../../../../assets/images/DeathModuleNew/addIcon.png";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import moment from "moment";

function AssetListing(props) {
  // Module category constants for better maintainability
  const MODULE_CATEGORIES = {
    INVESTMENT_TYPES: [
      "Private Placement and VC",
      "Precious Metals",
      "Cryptocurrency",
      "Business Interest",
      "Investment Portfolio",
    ],
    PURCHASE_PRICE_TYPES: [
      "Livestock",
      "General Household",
      "Club Membership",
      "Trust Deeds",
    ],
    VEHICLE_TYPES: ["auto - non-collectible", "motorcycle", "airplane", "boat"],
  };

  // Helper functions to check module categories
  const isInvestmentType = (moduleName) =>
    MODULE_CATEGORIES.INVESTMENT_TYPES.includes(moduleName);

  const isPurchasePriceType = (moduleName) =>
    MODULE_CATEGORIES.PURCHASE_PRICE_TYPES.includes(moduleName);

  const isVehicleType = (moduleName) =>
    MODULE_CATEGORIES.VEHICLE_TYPES.some(
      (type) => moduleName.toLowerCase() === type.toLowerCase()
    );

  const [allProperties, setAllProperties] = useState([]);
  const [activeItem, setActiveItem] = useState("");
  const [activeRoom, setActiveRoom] = useState();
  const [allItems, setAllItems] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isModal, setModal] = useState(false);
  const [showItems, setShowItems] = useState(false);
  const [showItemAdd, setShowItemAdd] = useState(false);
  const history = useHistory();

  const updateInventory = useCallback((item) => {}, []);
  const updateProperties = useCallback(() => {
    assetReport();
  }, []);

  const { module } = useParams();

  useEffect(() => {
    assetReport();
  }, []);
  let propertiesList = [];

  function calculateAPYandMonthlyInterest(asset) {
    const balance = Number(asset["Monetary Value"] || 0);
    const apr = Number(asset["Static"] || 0); // interest rate entered in %

    // Convert APR % to decimal
    const aprDecimal = apr / 100;

    // 1. APY formula
    const apy = (Math.pow(1 + aprDecimal / 12, 12) - 1) * 100;

    // 2. Monthly interest formula
    const monthlyInterest = balance * (aprDecimal / 12);

    return {
      APY: apy.toFixed(2), // %
      monthlyInterest: monthlyInterest.toFixed(2), // $
    };
  }

  async function assetReport() {
    try {
      setIsLoading(true);
      setAllProperties([]);
      let airplane = await MODULE_API.fetchItems({
        moduleName: `${module}`,
        pageNum: 1,
        limit: 10,
        body: {},
      });

      let records = airplane && airplane.records ? airplane.records : [];

      if (module === "Investment Portfolio") {
        records = await Promise.all(
          records.map(async (record) => {
            try {
              const payload = { clientModuleId: record.id };
              const response = await MODULE_API.getModuleStocks(payload);
              if (response && response.data && response.data.stocks) {
                const stocks = response.data.stocks;
                const totalAverageCost = stocks.reduce(
                  (acc, stock) => acc + (Number(stock.totalCost) ||Number(stock.averageCost) || 0),
                  0
                );
                const totalMarketValue = stocks.reduce(
                  (acc, stock) =>
                    acc + (Number(stock.approximateMarketValue) || 0),
                  0
                );

                record.totalAverageCost = totalAverageCost;
                record.totalMarketValue = totalMarketValue;
              }
            } catch (err) {
              console.log("Error fetching stocks for record", record.id, err);
            }
            return record;
          })
        );
      }

      setIsLoading(false);
      propertiesList =
        records &&
        records.map((properties) => {
          const costBasisDate = properties["Cost Basis Date"]
            ? new Date(properties["Cost Basis Date"])
            : null;

          const liabilityEnd = properties["Liability End"]
            ? new Date(properties["Liability End"])
            : null;
          const loanBalance = properties["Loan Balance"]
            ? Number(properties["Loan Balance"])
            : 0;

          const monetaryValue = properties["Monetary Value"]
            ? Number(properties["Monetary Value"])
            : 0;

          const equity = monetaryValue - loanBalance;
          // Avoid division by zero
          let ownership = 0;

          if (monetaryValue > 0) {
            ownership = (equity / monetaryValue) * 100;

            // Percentage should not exceed 100%
            if (ownership > 100) ownership = 100;
            if (ownership < 0) ownership = 0; // optional safeguard
          }

          const currentDate = new Date();
          let numberOfYears = null;
          let yearsFromNowToEnd = null;

          if (costBasisDate && liabilityEnd) {
            // 1) Years between costBasisDate and liabilityEnd
            const diffInMs = liabilityEnd - costBasisDate;
            numberOfYears =
              diffInMs > 0 ? diffInMs / (1000 * 60 * 60 * 24 * 365) : 0;
            numberOfYears = Number(numberOfYears.toFixed(0));

            // 2) Years from current date to liabilityEnd
            const diffNowMs = liabilityEnd - currentDate;
            yearsFromNowToEnd =
              diffNowMs > 0 ? diffNowMs / (1000 * 60 * 60 * 24 * 365) : 0;
            yearsFromNowToEnd = Number(yearsFromNowToEnd.toFixed(0));
          }

          const totalInvested = isInvestmentType(properties.module)
            ? module === "Investment Portfolio"
              ? Number(properties.totalAverageCost || 0)
              : Number(properties["Cost Basis"] || 0)
            : 0;

          const totalMarketValue = isInvestmentType(properties.module)
            ? module === "Investment Portfolio"
              ? Number(properties.totalMarketValue || 0)
              : Number(properties["Monetary Value"] || 0)
            : 0;

          const totalGrowth = totalMarketValue - totalInvested

          // Now safely compute ROI
          const ROI =
            totalInvested > 0
              ? ((totalGrowth / totalInvested) * 100).toFixed(2)
              : "0.00";

          const cashResult = calculateAPYandMonthlyInterest(properties);
          console.log("ROI", totalInvested, totalGrowth);

          return {
            id: properties.id,
            Owner: properties.Owner,
            module: properties.module,
            type: properties.type || 0,
            subType: properties.subType || 0,
            img: properties.image || tableimg,
            name: properties["Name of Asset"],
            total: properties.total || 0,
            "Account Type/Titled": properties["Account Type/Titled"],
            "Account Number": properties["Account Number"] || null,
            "Held Where": properties["Held Where"] || null,
            "Rate of Return": properties["Static"] || null,
            "Cost Basis Date": properties["Cost Basis Date"] || null,
            "Cost Basis": properties["Cost Basis"] || null,
            "Loan Interest Rate": properties["Loan Interest Rate"] || null,
            "Estimated Unrealized Gain/Loss":
              properties["Estimated Unrealized Gain/Loss"] || null,
            "Loan Balance": properties["Loan Balance"] || null,
            "Liability End": properties["Liability End"] || null,
            "Monetary Value": properties["Monetary Value"] || null,

            // ✅ NEW FIELD
            "Years Between Cost Basis & Liability End": numberOfYears,
            yearsFromNowToEnd: yearsFromNowToEnd,
            equity: equity ? equity.toFixed(2) : 0,
            valueAsOfDate: properties["Value as of Date"] || null,
            ownership: ownership ? ownership.toFixed(2) : 0.0,
            totalInvested: totalInvested.toFixed(2) || 0.0,
            totalGrowth: totalGrowth.toFixed(2) || 0.0,
            ROI: Number(ROI).toFixed(2) || 0.0,
            APY: Number(cashResult.APY).toFixed(2) || 0,
            monthlyInterest: Number(cashResult.monthlyInterest).toFixed(2) || 0,
          };
        });
      setAllProperties(propertiesList);
    } catch (error) {
      console.log("e ", error);
    }
  }

  function handleDelete(event, item, type) {
    swal({
      title: "Are you sure?",
      text: `Are you sure that you want to delete ${
        item.name || item["Name of Asset"] || module
      }?`,
      icon: "warning",
      dangerMode: true,
      buttons: true,
    }).then(async (doDelete) => {
      // ❌ If user clicked Cancel → do nothing
      if (!doDelete) return;

      // ✅ Only run this when user CONFIRMS delete
      setIsLoading(true);

      await MODULE_API.removeClientModule({
        clientModules: [item.id],
      });

      if (type === "property") {
        updateProperties();
        setActiveItem("");
        return;
      }

      if (type === "room") {
        await MODULE_API.getRecordTotal(activeItem.id, {
          attributes: ["total"],
        });
        setAllItems("");
        setShowItems(false);
        setShowItemAdd(false);
      } else {
        await MODULE_API.getRecordTotal(activeRoom, {
          attributes: ["currentValue"],
        });
        await MODULE_API.getRecordTotal(activeItem.id, {
          attributes: ["total"],
        });
      }

      updateInventory(activeItem);
    });
  }

  function handleEdit(event, item, type) {
    history.push(`/assets_new/attributes/${item.module}/${item.id}`);
  }
  function handleView(event, item) {
    history.push(`/assets_new/attributes/${item.module}/${item.id}/view`);
  }
  function moneyFormatter(value) {
    const formatter = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    });

    let result = formatter.format(value);
    console.log("Money :: ", result);
    return result;
  }
  const capitalizeFirstLetter = (string) => {
    return string.replace(/\b\w/g, (char) => char.toUpperCase());
  };
  return (
    <div style={{ position: "relative" }}>
      <Style.Main>
        <Style.Cards
          style={{
            borderBottom:
              allProperties && allProperties.length > 0
                ? "1px solid #F0F0F0"
                : "none",
          }}
        >
          <Style.SubCards
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <Style.CardsHead>
              <h3
                style={{
                  fontWeight: "bold",
                  fontFamily: "Poppins",
                  fontSize: "20px",
                }}
              >
                {module}
              </h3>
            </Style.CardsHead>
            <Style.PropertyAdd
              style={{
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <div style={{ marginRight: "1rem" }}>
                <h3 style={{ fontFamily: "Poppins", fontSize: "20px" }}>
                  Add {module}
                </h3>
              </div>
              <Link
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
                to={`/assets_new/attributes/${module}`}
              >
                <div
                  className="upload"
                  style={{ width: "28px", height: "28px" }}
                >
                  <img
                    src={addIcon1}
                    width={12}
                    height={12}
                    style={{ width: "16px", height: "16px" }}
                    alt="addicon"
                  ></img>
                </div>
                {/* <Style.AddBtn>
                  <img src={addIcon} />
               </Style.AddBtn>*/}
              </Link>
            </Style.PropertyAdd>
          </Style.SubCards>
          <Style.CardsMain
            style={{
              justifyContent:
                allProperties && allProperties.length > 0 ? "start" : "center",
              grid: allProperties && allProperties.length === 0 && "initial",
              padding: "10px",
              gap: "1rem",
            }}
          >
            {/* {allProperties? allProperties.length >0: <p>No record found.</p>} */}
            {allProperties && allProperties.length > 0 ? (
              allProperties.map((item, index) => (
                <Style.Card
                  key={index}
                  active={item.id == activeItem}
                  style={{ padding: "0", overflow: "hidden" }} // Override padding for the new layout
                >
                  {/* Image Section */}
                  <div
                    style={{
                      padding: "1.5rem 1rem 0.5rem",
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                      height: "220px",
                      alignItems: "center",
                    }}
                  >
                    <Style.Img
                      src={item.img}
                      style={{
                        width: "auto",
                        height: "100%",
                        maxHeight: "200px",
                        maxWidth: "100%",
                        objectFit: "contain",
                      }}
                    />
                  </div>

                  {/* Header: Title and Actions */}
                  <Style.CardHeader>
                    <Style.CardTitle>
                      {item.name ? item.name : "N/A"}
                    </Style.CardTitle>
                    <Style.CardIcons>
                      <Button
                        type="link"
                        icon="edit"
                        style={{ color: "black", fontSize: "18px" }}
                        onClick={(e) => {
                          handleEdit(e, item, "property");
                        }}
                      />
                      <Button
                        type="link"
                        icon="eye"
                        style={{ color: "black", fontSize: "18px" }}
                        onClick={(e) => {
                          handleView(e, item);
                        }}
                      />
                      <Button
                        type="link"
                        icon="delete"
                        style={{ color: "black", fontSize: "18px" }}
                        onClick={(e) => {
                          handleDelete(e, item, "property");
                        }}
                      />
                    </Style.CardIcons>
                  </Style.CardHeader>

                  {/* Main Value Section */}
                  <Style.CardValueSection>
                    <Style.CardValue>
                      {item["Monetary Value"]
                        ? moneyFormatter(item["Monetary Value"])
                        : "$0.00"}
                    </Style.CardValue>
                    <Style.CardLabel>
                      {isPurchasePriceType(module)
                        ? "Estimated Value"
                        : "Current Market Value"}
                    </Style.CardLabel>
                  </Style.CardValueSection>

                  {/* Progress / Equity Section */}
                  {!isPurchasePriceType(module) &&
                    !isInvestmentType(module) && module !== "Cash" && (
                      <Style.ProgressSection>
                        <Style.ProgressBar>
                          <Style.ProgressFill
                            percent={item.ownership ? item.ownership : 0}
                          />{" "}
                          {/* Placeholder percent as we don't have loan info */}
                        </Style.ProgressBar>
                        <Style.EquityText>
                          Equity:{" "}
                          {item.equity ? moneyFormatter(item.equity) : "$0.00"}{" "}
                          ({item.ownership ? item.ownership : 0.0}% Owned)
                        </Style.EquityText>
                      </Style.ProgressSection>
                    )}
                  {/* Footer Stats */}
                  <Style.StatsContainer>
                    <Style.StatBox>
                      {/* Placeholder for Icon */}
                      <div style={{ fontSize: "1.2rem" }}>
                        {isInvestmentType(module) ? (
                          <img src={conatinerIcon} width={32} alt="container" />
                        ) : isPurchasePriceType(module) ? (
                          <img src={purchaseIcon} width={32} alt="purchase" />
                        ) : (
                          <img src={percentIcon} width={32} alt="percent" />
                        )}
                      </div>
                      <Style.StatLabel>
                        {isPurchasePriceType(module)
                          ? "Purchase Price"
                          : isVehicleType(module)
                          ? "Int. Rate"
                          : isInvestmentType(module)
                          ? "Total Invested"
                          : module === "Cash"
                          ? "APY%"
                          : "Mtg. Rate"}
                      </Style.StatLabel>
                      <Style.StatValue>
                        {isPurchasePriceType(module)
                          ? item["Cost Basis"]
                            ? moneyFormatter(item["Cost Basis"])
                            : "N/A"
                          : isInvestmentType(module)
                          ? moneyFormatter(item.totalInvested)
                          : module === "Cash"
                          ? item.APY + "%"
                          : item["Loan Interest Rate"]
                          ? parseFloat(item["Loan Interest Rate"]).toFixed(2) +
                            "%"
                          : "N/A"}
                      </Style.StatValue>
                    </Style.StatBox>
                    {module !== "Cash" && (
                      <Style.StatBox>
                        {/* Placeholder for Icon */}
                        <div style={{ fontSize: "1.2rem" }}>
                          {isVehicleType(module) ? (
                            <img
                              src={downTrendIcon}
                              width={32}
                              alt="downTrend"
                            />
                          ) : (
                            <img src={growthIcon} width={32} alt="growth" />
                          )}
                        </div>
                        <Style.StatLabel>
                          {isPurchasePriceType(module)
                            ? "Current Value"
                            : "Total Growth"}
                        </Style.StatLabel>
                        <Style.StatValue
                          color={(() => {
                            const val = parseFloat(item["Monetary Value"]) || 0;
                            const cost = parseFloat(item["Cost Basis"]) || 0;
                            const growthValue = isPurchasePriceType(module)
                              ? val
                              : isInvestmentType(module)
                              ? item.totalGrowth
                              : parseFloat(
                                  item["Estimated Unrealized Gain/Loss"]
                                ) || 0;
                            return growthValue < 0 ? "red" : "#00b050"; // red for negative, green for positive
                          })()}
                        >
                          {(() => {
                            const val = parseFloat(item["Monetary Value"]) || 0;
                            const cost = parseFloat(item["Cost Basis"]) || 0;
                            const growthValue = isPurchasePriceType(module)
                              ? val
                              : isInvestmentType(module)
                              ? item.totalGrowth
                              : parseFloat(
                                  item["Estimated Unrealized Gain/Loss"]
                                ) || 0;
                            return growthValue >= 0
                              ? isPurchasePriceType(module)
                                ? moneyFormatter(growthValue)
                                : "+" + moneyFormatter(growthValue)
                              : moneyFormatter(growthValue);
                          })()}
                        </Style.StatValue>
                      </Style.StatBox>
                    )}
                    <Style.StatBox last>
                      {/* Placeholder for Icon */}
                      <div style={{ fontSize: "1.2rem" }}>
                        {isInvestmentType(module) ? (
                          <img
                            src={percentageIcon}
                            width={32}
                            alt="percentage"
                          />
                        ) : module === "Cash" ? (
                          <img src={cashIcon} width={32} alt="cash" />
                        ) : isPurchasePriceType(module) ? (
                          <img src={calanderIcon} width={32} alt="calendar" />
                        ) : (
                          <img src={clockIcon} width={32} alt="clock" />
                        )}
                      </div>
                      <Style.StatLabel>
                        {isInvestmentType(module)
                          ? "ROI"
                          : module === "Cash"
                          ? "Mo. Interest"
                          : isPurchasePriceType(module)
                          ? "Last Appraised"
                          : "Freedom Metric"}
                      </Style.StatLabel>
                      <Style.StatValue>
                        {isPurchasePriceType(module)
                          ? item.valueAsOfDate
                            ? moment(item.valueAsOfDate).format("YYYY")
                            : "N/A"
                          : isInvestmentType(module)
                          ? item.ROI + "%"
                          : module === "Cash"
                          ? moneyFormatter(item.monthlyInterest)
                          : item.yearsFromNowToEnd
                          ? item.yearsFromNowToEnd + " years Left"
                          : "N/A"}
                      </Style.StatValue>{" "}
                      {/* Static as per design/no data */}
                    </Style.StatBox>
                  </Style.StatsContainer>
                </Style.Card>
              ))
            ) : (
              <h1
                style={{
                  marginTop: "6rem",
                  width: "max-content",
                  textAlign: "center",
                }}
              >
                No Items to Display for this Asset Allocation.
              </h1>
            )}
          </Style.CardsMain>
        </Style.Cards>
      </Style.Main>
      <div>
        <Modal
          width={"58rem"}
          visible={isModal}
          footer={null}
          // onCancel={handleModalCancel}
          bodyStyle={{
            overflowY: "auto",
            maxHeight: "calc(100vh - 200px)",
          }}
        ></Modal>
      </div>
      <NewLoader isLoading={isLoading} />
      {/*<Loader isLoading={isLoading} /> */}
    </div>
  );
}

export default AssetListing;
